import { Component, OnInit, Input } from '@angular/core';
import { TicketService } from 'src/app/services/ticket.service';
import { GlobalService } from 'src/app/services/global.service';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from 'src/app/services/customer.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { UploadFileService } from 'src/app/services/upload-file.service';

@Component({
  selector: 'app-new-ticket',
  templateUrl: './new-ticket.component.html',
  styleUrls: ['./new-ticket.component.css']
})
export class NewTicketComponent implements OnInit {

  constructor(
    private modalService: NgbModal,
    private globals: GlobalService,
    private ticketService: TicketService,
    public activeModal: NgbActiveModal,
    private customerService: CustomerService,
    private upload: UploadFileService,
    private formBuilder: FormBuilder

  ) { }

  // Object

  userActive: any;
  // String
  token: string;
  cus: any;
  // Boolean
  new: boolean = true;
  operator: boolean = false;
  // Array
  tk: Array<any> = [];
  communications: Array<any> = [];
  customers: any;
  customer_id: number;
  forCustomer: boolean = false;
  file: any;
  nameList: any;

  uploadForm: FormGroup;

  amountFile: number;
  desc: boolean;
  nome: boolean;

  @Input() tickett


  ngOnInit() {
    if (!this.token) {
      this.token = this.globals.getToken();
    }
    this.uploadForm = this.formBuilder.group({
      profile: ['']
    });
    this.userActive = this.globals.storagedUser;
    this.checkProfile()
    this.selectedTicket();
    this.getCommunication();
    this.getCustomers();
  }

  checkProfile() {
    if (this.userActive.profile_id > 1) {
      this.operator = true;
    } else {
      this.operator = false;
    }
  }

  ticket(tick) {
    if (tick.ticket_name) {
      this.nome = true;
      document.getElementById("ticketTitolo").innerHTML = "";
    } else {
      this.nome = false;
      document.getElementById("ticketTitolo").innerHTML = "↓ Il campo è obbligatorio";
    }

    if (tick.description) {
      this.desc = true;
      document.getElementById("ticketDescription").innerHTML = "";
    } else {
      this.desc = false;
      document.getElementById("ticketDescription").innerHTML = "↓ Il campo è obbligatorio";
    }

    if (this.nome && this.desc == true) {
      let obj = {
        ticket: {
          ticket_name: tick.ticket_name,
          description: tick.description,
          priority: tick.priority,
          state: "Aperto"
        },
        assignTo: {
          customer_id: this.customer_id
        },

      }    
      this.ticketService.newTicket(this.token, obj).subscribe(
        res => {
          if(this.amountFile > 0)
            this.uploadFile(res.ticket_id)
            this.close();
        },
        err => {
          console.error(err);  
      })
    }
  }

  uploadFile(id){
    this.uploadForm.get('profile').setValue(this.file);
      const formData = new FormData();
      for(let i = 0; i < this.file.length; i++){
        formData.append('file', this.file[i], this.file[i].name);
      }
      this.upload.uploadTicketFile(this.token, formData, id).subscribe(
        res => {
          this.close();
        },
        err => { console.error(err) }
      );
  }

  getCustomers() {
    this.customerService.getCustomer(this.token).subscribe(
      res => {
        this.customers = res;
      },
      err => {
        console.error("Error on get customers", err);

      }
    )
  }

  show() {
    if (this.forCustomer) {
      this.forCustomer = false
    } else {
      this.forCustomer = true
    }
  }

  selectedTicket(){
    if(this.tickett){
      this.tk = this.tickett;
      this.new = false;
    }
  }

  communication(comm) {
    let obj: any = {
      text: comm
    }
    this.ticketService.sendCommunication(this.token, this.tickett.ticket_id, obj).subscribe(
      res => {
      },
      err => {
        console.error("Errore in sendCommunication", err);

      }
    )
  }

  getCommunication() {
    if (this.tickett) {
      this.ticketService.getTicketCommunication(this.token, this.tickett.ticket_id).subscribe(
        res => {
          this.communications = res
        },
        err => {
          console.error("Errore in getCommunication: ", err);
        }
      )
    } else {
    }
  }

  assignTo(cus) {
    this.customer_id = cus.customer_id;
  }

  onFileSelect(event){
    this.amountFile = event.target.files.length
    if (this.amountFile > 0 && event.target.files[0]) {
      this.file = event.target.files

      Array.from(event.target.files).forEach(file => {
        this.nameList.push(file)
      });
    }
  }

  canceling(){
    this.activeModal.close('cancel');
  }

  close(){
    this.activeModal.close();
  }

} 
